<template>
    <div class="desktop">
        <div class="menu-ctn">
            <div :key="index" class="menu-item" v-for="(item, index) in menu" @click="menuHandle(item)">
                <router-link :to="item.Url">
                    <el-image style="width: 100px; height: 100px" fit="fill" :src="downloadUrl + item.Vector" alt :onerror="defaultImg" />
                    <p>{{ item.Name }}</p>
                </router-link>
            </div>
        </div>
        <div class="league-view" v-if="permission.addUnion || permission.joinUnion || unions.length > 0">
            <div class="league-content">
                <div class="header">
                    <span class="header-name">企业大联盟</span
                    ><el-button type="text" icon="el-icon-refresh" class="header-reflash" @click="reflashUnion">刷新联盟数据</el-button>
                </div>
                <div class="menu-ctn">
                    <div :key="index" class="menu-item" v-for="(item, index) in unions">
                        <div @click="gotoUnion(item.UnionId, index)">
                            <el-image class="menu-image" fit="fill" :src="downloadUrl + item.LogoUrl" :onerror="defaultImg" :title="item.UnionName" />
                            <div class="loading" v-if="item.loading">
                                <el-progress :width="80" class="progress" type="circle" :percentage="item.percentage" />
                            </div>
                            <p class="menu-name">
                                {{ item.Abbr }}
                                <img
                                    src="@/assets/images/admin.png"
                                    style="width: 20px; height: 20px; margin-top: 2px; margin-bottom: 2px; margin-left: 3px"
                                    v-if="item.IsAdmin"
                                    title="管理员"
                                />
                            </p>
                        </div>
                    </div>
                    <div class="menu-item league-add" v-if="permission.joinUnion || permission.addUnion" @click="unionOp">
                        <div class="image-add">
                            <i class="el-icon-plus"></i>
                        </div>
                        <p>{{ permission.addUnion ? '创建' + (permission.joinUnion ? ' / ' : '') : '' }}{{ permission.joinUnion ? '加入' : '' }}联盟</p>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="创建联盟" :visible.sync="dialogCreateVisible" width="1000px">
            <div class="dialog-content" v-if="dialogCreateVisible">
                <CreateUnion @closeDialog="closeCreateDialog"></CreateUnion>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="加入联盟" :visible.sync="dialogJoinVisible" width="1000px">
            <div v-if="dialogJoinVisible">
                <JoinUnion @closeDialog="closeJoinDialog"></JoinUnion>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import CreateUnion from '@/components/entpUnion/entityManage/createUnion';
import JoinUnion from '@/components/entpUnion/entityManage/joinUnion';
export default {
    name: 'desktop',
    components: {
        CreateUnion,
        JoinUnion
    },
    data() {
        return {
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
            downloadUrl: this.$util.QN_URL_BASE,
            dialogCreateVisible: false,
            dialogJoinVisible: false,
            menu: {},
            unions: {},
            navBtn: {},
            permission: {}
        };
    },
    mounted() {
        let that = this;
        that.initPage();
        //登录进来时还没有拿到权限的
        that.$util.getTreeForDT().then(() => {
            that.permission = that.$util.getPermission('Union');
        });
        this.menuHandle();
    },
    methods: {
        menuHandle(row) {
            if (row && row.Name) {
                document.title = row.Name;
            } else {
                document.title = '车回佳企业客户端管理系统';
            }
        },
        initPage() {
            this.getHomeModules();
            this.getUnionDatas(false);
            this.getEntpAllPrintModels();
        },
        // 获取首页模块
        getHomeModules() {
            this.$util.getHomeModules('3').then(data => {
                this.menu = data;
            });
        },
        // 获取打印模板
        getEntpAllPrintModels() {
            this.$util.getEntpAllPrintModels(true);
        },
        getUnionDatas(isClear) {
            this.$util.getUnionDatas(isClear).then(data => {
                this.unions = data.map(m => {
                    return {
                        ...m,
                        loading: false,
                        percentage: 0
                    };
                });
            });
        },
        unionOp() {
            let that = this;
            if (that.permission.joinUnion && that.permission.addUnion) {
                //要询问是加入还是创建
                that.$confirm('您是要进行哪种操作？', '提示', {
                    confirmButtonText: '创建联盟',
                    cancelButtonText: '加入联盟',
                    type: 'warning',
                    center: false,
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        //创建联盟
                        that.dialogCreateVisible = true;
                    })
                    .catch(action => {
                        if (action === 'cancel') {
                            //加入联盟
                            that.dialogJoinVisible = true;
                        }
                    });
            } else if (!that.permission.joinUnion && that.permission.addUnion) {
                //创建
                that.dialogCreateVisible = true;
            } else if (that.permission.joinUnion && !that.permission.addUnion) {
                //加入
                that.dialogJoinVisible = true;
            } else {
                that.$util.warningMsg('您没有创建或加入联盟的权限，请联系车回佳客服');
            }
        },
        closeCreateDialog(isEdit) {
            this.dialogCreateVisible = false;
            if (isEdit) {
                this.getUnionDatas(true);
            }
        },
        closeJoinDialog() {
            this.dialogJoinVisible = false;
        },
        reflashUnion() {
            this.getUnionDatas(true);
        },
        gotoUnion(unionId, index) {
            let that = this;
            if (that.unions[index].loading) return;
            that.unions[index].loading = true;
            if (unionId) {
                //现要判断联盟是否已经被禁用或者成员是否已经被踢出联盟
                that.$util
                    .axiosGet({
                        url: '/api/EntpUnions/CheckUnionState',
                        data: {
                            UnionId: unionId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        that.unions[index].percentage = 50;
                        let currentUnion = that.$util.getLocalStorage('currentUnion');
                        if (!currentUnion) {
                            that.$util.setLocalStorage('currentUnion', unionId);
                            that.$store.commit('updateReflashUnion', true);
                        } else {
                            if (currentUnion !== unionId) {
                                that.$util.setLocalStorage('currentUnion', unionId);
                                that.$store.commit('updateReflashUnion', true);
                            }
                        }
                        that.$util.getUnionTree().then(() => {
                            that.unions[index].percentage = 100;
                            setTimeout(() => {
                                that.$router.push('/entpUnion/unionManage/unionInfoes');
                                that.unions[index].loading = false;
                            }, 500);
                        });
                    })
                    .catch(() => {
                        that.reflashUnion();
                    });
            } else that.$util.warningMsg('联盟信息异常，请刷新后重试');
        }
    }
};
</script>

<style lang="less" scoped>
.desktop {
    width: 100%;
    height: 100%;
    background: url('../../../assets/images/bg.jpg') no-repeat;
    background-size: cover;
    background-repeat:no-repeat;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    overflow-y: auto;
}
.msg-ctn {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 300px;
    height: 500px;
    overflow: auto;
    background: rgba(255, 255, 255, 0.7);
}
.menu-ctn {
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
}
.menu-item {
    margin: 10px;
    text-align: center;
    color: #252a2f;
    a {
        color: #252a2f;
    }
    border-radius: 12px;
    padding: 10px 20px;
    background: rgba(255, 255, 255, 0.7);
}
.league-view {
    width: 100%;
    padding: 20px;
    .league-content {
        padding: 20px;
        box-sizing: border-box;
        background-color: rgba(255, 255, 255, 0.7);
        border-radius: 20px;
        .header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            border-bottom: 1px solid #7f7f7f;
        }
        .header-name {
            color: #000;
            font-size: 24px;
            padding: 0 0 12px 20px;
        }
        .header-reflash {
            padding: 0 20px 12px 0;
        }
        .menu-ctn {
            padding: 10px 0 0 0;
            height: 162px;
            overflow-y: auto;
            .menu-item {
                position: relative;
                margin: 0;
                background-color: transparent;
            }
            .menu-image,
            .loading {
                width: 100px;
                height: 100px;
                overflow: hidden;
                border-radius: 18px;
            }
            .loading {
                position: absolute;
                z-index: 1;
                top: 10px;
                left: 50%;
                transform: translateX(-50%);
                background-color: rgba(255, 255, 255, 0.7);
                .progress {
                    top: 10px;
                }
            }
            .menu-name {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
            }
            .league-add {
                cursor: pointer;
                .image-add {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100px;
                    height: 100px;
                    margin-bottom: 10px;
                    font-weight: 600;
                    font-size: 50px;
                    color: #bfbfbf;
                    background-color: #fff;
                    border-radius: 16px;
                }
            }
        }
    }
}
</style>
